/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "australianPassportTitle",
    label: "Australian passport"
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_passportdvs_number",
    label: "Passport number",
    fieldRequired: true,
    validation: { required: true, max: 11, regex: /^[A-Za-z]{1,2}\d{6,7}$/ },
    hint: "Enter all letters and numbers as they appear on the passport."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_passportdvs_givenname",
    label: "First name",
    fieldRequired: true,
    validation: { required: true },
    hint: "Enter exactly as it appears on your passport."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_passportdvs_middlename",
    label: "Middle name",
    hint: "Enter exactly as it appears on your passport."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_passportdvs_surname",
    label: "Last name",
    fieldRequired: true,
    validation: { required: true, max: 31 },
    hint: "Enter exactly as it appears on your passport."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_passportdvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_passportdvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];